export default {"src":"/_next/static/media/ES.1f1ce1f3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};